<template>
  <div class="demo">
    <el-select @change="updateSheng" v-model="shengId" clearable >
      <el-option
        v-for="sheng in jsonList"
        :key="sheng.code"
        :value="sheng.code"
        :label="sheng.name"
      ></el-option>
    </el-select>
    <el-select @change="updateShi" v-model="shiId" clearable  >
      <el-option v-for="shi in shiData" :value="shi.code" :key="shi.code" :label="shi.name"></el-option>
    </el-select>
    <span v-if="isXian">
      <el-select @change="updateXian" v-model='xianId' clearable  >
        <el-option :value="xian.code" v-for="xian in xianData" :key="xian.code" :label="xian.name"></el-option>
      </el-select>
    </span>
    <el-button @click="addCity" v-if="showAdd">添加城市</el-button>
  </div>
</template>

<script>
import cityJson from '@/libs/common/cityJson'
export default {
  data() {
    return {
      shiData: [],
      xianData: [],
      shengId: null,
      shiId: null,
      xianId: null,
      shengName: null,
      shiName: null,
      xianName: null,
      cityIds: []
    };
  },
  props: {
    isXian: {
      type: Boolean,
      default: false
    },
    showAdd: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    deep: true,
    shengId: {
      handler(newVal, oldVal) {
        for (let i = 0; i < this.jsonList.length; i++) {
          if (this.jsonList[i].code === newVal) {
            this.shiData = this.jsonList[i].cityList;
            this.shengName = this.jsonList[i].name
            this.shiName = null
            this.xianName = null
            return newVal
          }
        }
        this.shengName = null
        return null
      }
    },
    shiId: {
      handler(newVal, oldVal) {
        for (let i = 0; i < this.shiData.length; i++) {
          if (this.shiData[i].code === newVal) {
            this.xianData = this.shiData[i].areaList;
            this.shiName = this.shiData[i].name
            this.xianName = null
            return newVal
          }
        }
        this.shiName = null
        return null
      }
    },
    xianId: {
      handler(newVal, oldVal) {
        for (let i = 0; i < this.xianData.length;i++) {
          if (this.xianData[i].code === newVal) {
            this.xianName = this.xianData[i].name
            return newVal
          }
        }
        this.xianName = null
        return null
      }
    },
  },
  methods: {
    // 设置城市县
    setCity(obj) {
      this.shengId = obj.sheng + ''
      this.shiId = obj.shi + ''
      this.xianId = obj.xian + ''
    },
    updateSheng(e) {
      this.shiId = null
      this.xianId = null
      setTimeout(() => {
        this.sumbit()
      }, 50)
    },
    updateShi(e) {
      this.xianId = null
      setTimeout(() => {
        this.sumbit()
      }, 50)
    },
    updateXian(e) {
      setTimeout(() => {
        this.sumbit()
      }, 50)
    },
    addCity() {
      let flag = this.cityIds.some(item => {
        return item.cityId === this.shiId
      })
      if (!flag) {
        this.cityIds.push({
          cityId: this.shiId,
          cityName: this.shiName
        })
        this.$emit('addCity', this.cityIds)
      }
    },
    sumbit () {
      this.$emit('Citychange', {
        sheng: {
          name: this.shengName,
          code: this.shengId
        },
        shi: {
          name: this.shiName,
          code: this.shiId
        },
        xian: {
          name: this.xianName,
          code: this.xianId
        }
      });
      this.$emit('input', this.shiId)
    }
  },
  created() {
    this.jsonList = cityJson;
  }
};
</script>

<style lang='less' scoped>
.el-select {
  margin-right: 10px;
}
</style>
